import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button } from '../Button/Button';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { camelizeKeys, decamelizeKeys } from 'humps';
import { format, addHours, setMinutes } from 'date-fns';
import DatePicker from 'react-datepicker';
import { pl } from 'date-fns/locale';

export const OrderDateTimeConfirmationModal = ({
  onModalClose,
  isOpen,
  onStatusChange = () => { },
  order = null,
  routeId = null
}) => {
  const [loading, setLoading] = useState();

  const initialConfirmedAt = addHours(setMinutes(new Date(), 0), 2);
  initialConfirmedAt.setSeconds(0);
  initialConfirmedAt.setMilliseconds(0);

  const formik = useFormik({
    initialValues: {
      confirmBy: initialConfirmedAt,
    },
    validationSchema: Yup.object({
      confirmBy: Yup.date().notRequired(),
    }),

    onSubmit: async (values, formik) => {
      const csrfToken = document
        .querySelector('meta[name="csrf-token"]')
        ?.getAttribute('content');

      try {
        setLoading(true);

        const url = routeId ? `/admin/routes/askforconfirm/${routeId}` : `/admin/order-delivery-confirmations/${order.id}/ask`;

        const response = await fetch(url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
          },
          body: JSON.stringify(decamelizeKeys(values)),
        });

        if (order) {
          const data = await response.json();
          onStatusChange(camelizeKeys(data));
        }

        formik.resetForm();
        setLoading(false);
        toastr.success(__('orders.modal.send_sms.message_success'));
        onModalClose();
      } catch (error) {
        setLoading(false);
        toastr.error(__('orders.modal.send_sms.message_error'));
      }
    },
  });

  const handleClose = () => {
    formik.resetForm();
    onModalClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      className="max-90-vh"
      contentClassName="max-90-vh"
    >
      <ModalHeader toggle={handleClose}>{__('routes.modals.sms_modal.confirmation.header')}</ModalHeader>

      <ModalBody>
        <form id="confirmationForm" onSubmit={formik.handleSubmit}>
          <label htmlFor="message" className="form-label">
            {__('routes.modals.sms_modal.confirmation.label')}
          </label>
          <DatePicker
            className="form-control"
            wrapperClassName="col-12"
            selected={formik.values.confirmBy ? new Date(formik.values.confirmBy) : initialConfirmedAt}
            onChange={(date) => {
              formik.setFieldValue('confirmBy', format(date, 'yyyy-MM-dd HH:mm'));
            }}
            locale={pl}
            showTimeSelect
            dateFormat="yyyy-MM-dd HH:mm"
            placeholderText={__('routes.loading_date_time_placeholder')}
          />
        </form>
      </ModalBody>

      <ModalFooter>
        <div className="d-flex w-100 justify-content-between">
          <div>
            <Button
              className="btn-secondary mr-1"
              onClick={handleClose}
            >
              {__('app.back')}
            </Button>

            <Button
              type="submit"
              className="btn-primary"
              onClick={formik.submitForm}
              disabled={loading || !formik.isValid}
            >
              {__('app.send')}
            </Button>
          </div>
        </div>
      </ModalFooter>
    </Modal>
  );
};
